import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-dark text-secondary py-4 border-top border-secondary border-opacity-10 w-100">
      <div className="container text-center">
        <h6 className="text-white fw-black italic text-uppercase mb-1" style={{ letterSpacing: '1px' }}>
          FRÉQUENCE<span className="text-danger">974</span>
        </h6>
        <p className="mb-0" style={{ fontSize: '10px', opacity: '0.4' }}>
          © 2026 FRÉQUENCE 974. TOUS DROITS RÉSERVÉS.
        </p>
      </div>

      <style>{`
        /* Assure que le body n'a pas de fond blanc qui dépasse */
        footer {
          margin-top: 0 !important; 
          position: relative;
          z-index: 10;
        }
      `}</style>
    </footer>
  );
};

export default Footer;